import { Injectable } from '@angular/core';
var CarouselConfig = (function () {
    function CarouselConfig() {
        /** Default interval of auto changing of slides */
        this.interval = 5000;
        /** Is loop of auto changing of slides can be paused */
        this.noPause = false;
        /** Is slides can wrap from the last to the first slide */
        this.noWrap = false;
        this.keyboard = false;
    }
    return CarouselConfig;
}());
export { CarouselConfig };
CarouselConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
CarouselConfig.ctorParameters = function () { return []; };
//# sourceMappingURL=carousel.config.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/carousel/carousel.config.js
// module id = ../../../../angular-bootstrap-md/carousel/carousel.config.js
// module chunks = 3